import styled from 'styled-components';

const ReviewNote = styled.div`
  font-size: 0.9em;
  margin-top: ${props => (props.admin === true ? '0' : '1em')};
  margin-bottom: 0;
`;

export default ReviewNote;
